import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MaintenanceWindowPreviewPatchManagementWebComponentSchema } from '../types';

export class MaintenanceWindowPreviewPatchManagementBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(
    maintenanceWindowId: string
  ): Promise<MaintenanceWindowPreviewPatchManagementWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
